import { RetrieveSignatureSessionResponseBody } from 'bff'
import { useReactiveSignatureSession } from '../../../../../hooks/useReactiveSignatureSession'
import { QRCodeSVG } from 'qrcode.react'
import { useCallback, useEffect, useState } from 'react'
import { Spinner } from 'ui'
import { SkeletonQrComposition } from '../../../../SkeletonQrComposition'
import { useSignatureSession } from '../../../../../hooks/useSignatureSession'

export interface SignatureSessionMethodProps {
  onSignatureReceived: (signature: string) => void
  createSession: () => Promise<RetrieveSignatureSessionResponseBody>
  retrieveSignatureSession: () => Promise<RetrieveSignatureSessionResponseBody>
  expireSignatureSession: () => Promise<void>
}

const SignatureSessionQRCode = ({
  initialData,
}: {
  initialData: RetrieveSignatureSessionResponseBody
}) => {
  const { query } = useReactiveSignatureSession(initialData)

  const sideHandleAnchor = useCallback((e: any) => {
    // TODO: Fix anchor click
    e.preventDefault()
    window.open(e.target.href, '_blank')
  }, [])

  return (
    <div className='w-full flex items-center justify-center flex-col text-center space-y-8'>
      <div>
        <p className='text-sm font-medium text-start'>
          Escanea el código QR con tu celular para firmar. Manténlo abierto
          hasta que hayas firmado.
        </p>
      </div>
      <QRCodeSVG height={200} width={200} value={query.data.session_url} />
      <p className='text-[9.5px] text-muted-foreground max-w-lg w-full text-start'>
        Al avanzar con tu firma electrónica, reconoces y consientes que se
        utilizará para firmar el documento indicado y posee la misma validez
        legal que una firma a mano. Al concluir el proceso de firma electrónica,
        confirmas tu entendimiento y aceptación de estas condiciones. Consulta
        la{' '}
        <a
          href={`${process.env.NEXT_PUBLIC_WEB_APP_BASE_URL}/legal/consent`}
          className='underline'
          onClick={sideHandleAnchor}
        >
          divulgación de firma electrónica
        </a>{' '}
        completa.
      </p>
      {query.data.status === 'opened' && <Spinner />}
    </div>
  )
}

export const withSignatureSessionOnMount = <
  T extends {
    initialSignatureSession: RetrieveSignatureSessionResponseBody
  }
>(
  Component: React.ComponentType<T>
) => {
  return (props: SignatureSessionMethodProps) => {
    const signatureSession = useSignatureSession({
      createSession: props.createSession,
    })

    if (!signatureSession.session || signatureSession.isLoading)
      return <SkeletonQrComposition />

    //@ts-ignore
    return <Component initialSignatureSession={signatureSession.session} />
  }
}

export const SignatureQRCode = withSignatureSessionOnMount(
  ({ initialSignatureSession }) => (
    <SignatureSessionQRCode initialData={initialSignatureSession} />
  )
)
